module.exports = __webpack_public_path__ + "img/laboratorio_16-9_960.e63b9367.webp";